<template>
  <div>
    <slot v-bind="{ handleClickUploadBtn, loading, maxFileSize, fileType }"></slot>
    <input
      ref="fileInput"
      type="file"
      accept="audio/*"
      @change="handleFileUpload"
      style="visibility: hidden;height: 0;width: 0;"
    />
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'UploadAudio',
  props: ['value'],
  data() {
    return {
      loading: false,
      audioFile: {
        file: null,
        filename: null,
        contentType: null,
        duration: null
      },
      maxFileSize: 10,
      fileType: ['mpeg', 'wav']
    }
  },
  methods: {
    handleClickUploadBtn() {
      this.$refs.fileInput.click()
    },
    async handleFileUpload(event) {
      this.loading = true
      this.audioFile = {
        file: null,
        filename: null,
        contentType: null,
        duration: null
      }

      const file = event.target.files[0]
      if (file.size > this.maxFileSize * 1000000) {
        alert(`File is too big!`)
        await this.$swal.fire({
          type: 'error',
          title: this.$t(`ไฟล์มีขนาดใหญ่เกิน ${this.maxFileSize}mb`)
        })
      } else if (
        !this.fileType.some(type => {
          return file.type.includes(type)
        })
      ) {
        await this.$swal.fire({
          type: 'error',
          title: this.$t(`นามสกุลไฟล์ไม่ถูกต้อง ${this.fileType.join(', ')}`)
        })
      } else {
        const audioFile = await this.handleFileUploadPromise(event)
        await this.handleUploadToServer(audioFile)
      }
      this.loading = false
    },
    handleFileUploadPromise(event) {
      return new Promise(resolve => {
        const file = event.target.files[0]
        const reader = new FileReader()

        reader.onload = event => {
          // Create a new audio element and set the source to the blob URL
          const audio = new Audio()
          audio.src = URL.createObjectURL(file)

          // Listen for the audio to load metadata
          audio.addEventListener('loadedmetadata', function() {
            resolve({
              file: file,
              filename: file.name,
              contentType: file.type,
              duration: audio.duration
            })
          })
        }

        // Read the selected file as a blob
        reader.readAsArrayBuffer(file)
      })
    },
    async handleUploadToServer(audioFile) {
      try {
        let form_data = new FormData()
        form_data.append('data', audioFile.file)

        delete axios.defaults.headers.common['AUTHORIZATION']
        const response = await axios.post('https://apis.psyjai.com/uploadmedia/', form_data)
        if (response.status === 200) {
          this.$emit('onChangeFile', { url: response.data.url, duration: audioFile.duration })
        }
      } catch (error) {
        console.error(error)
        await this.$swal.fire({
          type: 'error',
          title: error.toString()
        })
      }
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/flow/UploadAudio.vue